export class ErrorModel {
    
    constructor(errorMessage:string){
        this.errorMessage = errorMessage;
    }

    errorMessage: string;
}